import React from 'react';

import { CardContainer, HeaderText } from './styles';
import type { RuleSummaryProps } from './RuleSummary';
import RuleSummary from './RuleSummary';
import type { RuleBreakdownProps } from './RuleBreakdown';
import RuleBreakdown from './RuleBreakdown';


type RuleCardProps = RuleBreakdownProps & RuleSummaryProps & {
  title: string;
  newThresholdValue: number | undefined;
  onSaveNewThresholdValue?: Function;
  onManualThresholdValueChange?: Function;
  manuallyEditedValue?: number;
  isManuallyEditing?: boolean;
  isEditable?: boolean;
};

const RuleCard: React.FC<RuleCardProps> = ({
  title,
  evaluationPercentile,
  numOfEvaluations,
  thresholdType,
  threshold,
  thresholdValue,
  totalEvaluations,
  newThresholdValue,
  onSaveNewThresholdValue,
  onManualThresholdValueChange,
  manuallyEditedValue,
  isManuallyEditing,
  isEditable,
}) => (
  <CardContainer alignItems="flex-start" direction="column" gap={2}>
    <HeaderText>{title}</HeaderText>
    <RuleSummary
      threshold={threshold}
      thresholdValue={thresholdValue}
    />
    <RuleBreakdown
      evaluationPercentile={evaluationPercentile}
      numOfEvaluations={numOfEvaluations}
      thresholdType={thresholdType}
      thresholdValue={thresholdValue}
      totalEvaluations={totalEvaluations}
      newThresholdValue={newThresholdValue}
      onSaveNewThresholdValue={onSaveNewThresholdValue}
      onManualThresholdValueChange={onManualThresholdValueChange}
      manuallyEditedValue={manuallyEditedValue}
      isManuallyEditing={isManuallyEditing}
      isEditable={isEditable}
    />
  </CardContainer>
);

export default RuleCard;
